import React, { createContext, useState, useContext } from 'react';

// Create a context for loading
const LoadingContext = createContext();

// A hook to use the LoadingContext easily
export const useLoading = () => {
    return useContext(LoadingContext);
};

// Provider component that wraps around components to provide loading state
export const LoadingProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
            {children}
        </LoadingContext.Provider>
    );
};
